export default import.meta.ROLLUP_FILE_URL_BBLVH$sL;